import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import NotFound from "../../components/not-found/NotFound";
import { Link, useSearchParams } from "react-router-dom";
import IconButton from "../../components/Button/IconButton";
import { DatePicker, Select } from "../../components/Form";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useDebounce from "../../hooks/useDebounce";
import { IoSearch } from "react-icons/io5";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import findSerialNumber from "../../utils/findSerialNumber";
import { toastMessage } from "../../utils/toastMessage";
import common from "../../routes/common";
import { dateFormat, dateFormatUtc } from "../../utils/dateFormat";
import scrollToUp from "../../utils/scrollToUp";
import { CapitalizeFirstWord } from "../../utils/CapitalizeFirstWord";
import Loader from "../../comman/Loader";
import { fetchQueryListApi } from "../../services/supportManagement/index";
import ModalBox from "../../components/modal/ModalBox";
import { emitData, socketConnection } from "../../utils/webSocketServices";
import useButtonLoader from "../../hooks/UseButtonLoader";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DescriptionModel from "../../components/imagePreview/DescriptionModel";
import { charLimit } from "../../utils/charLimit";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { dashboardSupportInsightsApi } from "../../services/dashboard";
import { Paper, Typography, FormControl, InputLabel, Select as MuiSelect, MenuItem, TextField } from "@mui/material";
import useDownloadWithPassword from "../../hooks/useDownloadWithPassword";
import csv from "../../Assests/image/csv.svg";
import ResponsiveAnalytics from "../../components/ResponsiveAnalytics";


const { NOT_FOUND } = common;

const SupportManagement = () => {
  let URL = process.env.REACT_APP_API_URL;
  const [buttonRef, buttonLoader] = useButtonLoader("Yes");
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  let pageLimit = +searchParam.get("limit") || 10;

  const [search, setSearch] = useState(
    getLocalStorage("supportList", "search") || ""
  );
  const debounceValue = useDebounce(search || "", 300);
  const [total, setTotal] = useState(0);
  const [queryList, setQueryList] = useState([]);
  const [eventId, setEventId] = useState({});
  const [viewModal, setViewModal] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [status, setStatus] = useState("");
  const [userType, setUserType] = useState(searchParam.get("userType") || "user");
  const [descriptionModel, setDescriptionModel] = useState(false);
  const [description, setDescription] = useState("");
  const [totalCompleted, setTotalCompleted] = useState(0);
  const [totalPending, setTotalPending] = useState(0);
  const [supportInsights, setSupportInsights] = useState({});
  const [date, setDate] = useState();
  const [problemType, setProblemType] = useState("");

  // Time range filter states
  const [timeRange, setTimeRange] = useState(searchParam.get("timeRange") || "");
  const [timeRangeStartDate, setTimeRangeStartDate] = useState(searchParam.get("timeRangeStartDate") || "");
  const [timeRangeEndDate, setTimeRangeEndDate] = useState(searchParam.get("timeRangeEndDate") || "");
  
  // Time range options
  const timeRangeOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "last30days", label: "Last 30 Days" },
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "custom", label: "Custom Range" }
  ];

  // handle all hooks
  const { loading, requestDownload, DownloadPasswordModal } = useDownloadWithPassword();

  useEffect(() => {
    setLocalStorage("supportList", "search", search);
  }, [search]);

  const handleExcelDownload = () => {
    try {
      const url = `${URL}/admin/support/download`;
      const params = {
        filter: {}
      };
      
      // Add all current filters to the export
      if(search) {
        params.filter.search = search;
      }
      if (userType) {
        params.filter.userType = userType;
      }
      if (problemType) {
        params.filter.problemType = problemType;
      }
      if (date) {
        params.filter.date = date;
      }
      if (timeRange) {
        params.filter.timeRange = timeRange;
      }
      if (timeRangeStartDate) {
        params.filter.timeRangeStartDate = timeRangeStartDate;
      }
      if (timeRangeEndDate) {
        params.filter.timeRangeEndDate = timeRangeEndDate;
      }
      
      requestDownload(url, `support-excel-file-${dateFormat(new Date())}`, params);
    } catch (e) {
      console.log(e.message);
    }
  };

  const handlePageLimitChange = (event) => {
    const newLimit = parseInt(event.target.value);
    searchParam.set("limit", newLimit);
    setSearchParam(searchParam);
  };

  // Time range handler
  const handleTimeRangeChange = (value) => {
    setTimeRange(value);
    if (value !== 'custom') {
      setTimeRangeStartDate("");
      setTimeRangeEndDate("");
    }
  };

  // Time range date change handler
  const handleTimeRangeDateChange = (type, value) => {
    if (type === 'start') {
      setTimeRangeStartDate(value);
    } else {
      setTimeRangeEndDate(value);
    }
  };

  const USER_TYPE = [
    {
      id: 1,
      name: "User",
      value: "user"
    },
    {
      id: 2,
      name: "Consultant",
      value: "cons"
    },
  ]
  const STATUS = [
    {
      id: 1,
      name: "Consultant",
      value: "consultant"
    },
  ]

  let PROBLEM_TYPE = [
    {
      id: 1,
      name: "COINS",
      value: "COINS"
    },
    {
      id: 2,
      name: "LIVE",
      value: "LIVE"
    },
    
    {
      id: 3,
      name: "MEDITATION",
      value: "MEDITATION"
    },
    
    {
      id: 4,
      name: "CONSULTANT",
      value: "CONSULTANT"
    },
    
    {
      id: 5,
      name: "REMEDY",
      value: "REMEDY"
    },
    
    {
      id: 6,
      name: "VASTU",
      value: "VASTU"
    },
    
    {
      id: 7,
      name: "TECHNICAL",
      value: "TECHNICAL"
    },

    {
      id: 8,
      name: "COMMUNITY",
      value: "COMMUNITY"
    },
    
    {
      id: 9,
      name: "OTHERS",
      value: "OTHERS"
    },

    {
      id: 10,
      name: "CONSULTANT_QUERY",
      value: "CONSULTANT_QUERY"
    },

    {
      id: 11,
      name: "QUERY",
      value: "QUERY"
    },

    {
      id: 12,
      name: "ADMIN",
      value: "ADMIN"
    },
    
    
  ]


  // useEffect(() => {
  //   setLocalStorage("queryList", "search", search);
  // }, [search]);

  const statusHandler = (value) => {
    if (status === value) {
      searchParam.delete("status");
    } else {
      searchParam.set("status", Boolean(value));
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };

  const handleUserTypeTab = (value) => {
    const selectedType = value || "";
    setUserType(selectedType);
    if (selectedType) {
      searchParam.set("userType", selectedType);
    } else {
      searchParam.delete("userType");
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
    getQueryList(null, selectedType);
    getSupportInsights(selectedType);
  };

  //--------------support-insights-Api----------------------------------

  const getSupportInsights = async (filterUserType = null) => {
    try {
      const userTypeToUse = filterUserType !== null ? filterUserType : userType;
      const payload = {};
      if (userTypeToUse) payload.userType = userTypeToUse;
      const { data } = await dashboardSupportInsightsApi(payload);
      if (data.code === 200) {
        setSupportInsights(data?.result || {});
      } else {
        toastMessage(data.message, "error", "supportInsights");
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  //------------------request-listing-Api----------------------------------
  const getQueryList = async (debounceValue = null, overrideUserType = null) => {
    try {
      showLoader();
      const sendData = {
        page: `${activePage}`,
        limit: "10",
      };
      if (debounceValue) {
        sendData.page = "1";
        sendData.search = debounceValue;
        searchParam.delete("page");
        setSearchParam(searchParam);
      }
      if (search) {
        sendData.search = search;
      }
      if (status) {
        sendData.status = status;
      }
      if (date) {
        sendData.date = date;
      }
      const currentUserType = overrideUserType !== null ? overrideUserType : userType;
      if (currentUserType) {
        sendData.userType = currentUserType;
      }
      if (problemType) {
        sendData.problemType = problemType;
      }
      
      // Time range filters
      if (timeRange) {
        sendData.timeRange = timeRange;
      }
      if (timeRangeStartDate) {
        sendData.timeRangeStartDate = timeRangeStartDate;
      }
      if (timeRangeEndDate) {
        sendData.timeRangeEndDate = timeRangeEndDate;
      }
      
      setQueryList([]);
      const { data } = await fetchQueryListApi(sendData);
      if (data.code === 200) {
        setQueryList(data?.result?.list || []);
        setTotal(data?.result?.total || 0);
        setTotalCompleted(data?.result?.totalCompleted || 0);
        setTotalPending(data?.result?.totalPending || 0);
        scrollToUp();
      } else {
        setQueryList([]);
        setTotal(0);
        toastMessage(data.message, "error", "queryList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  const applyFilter = () => {
    // Update URL parameters for time range
    if (timeRange) {
      searchParam.set("timeRange", timeRange);
    } else {
      searchParam.delete("timeRange");
    }
    if (timeRangeStartDate) {
      searchParam.set("timeRangeStartDate", timeRangeStartDate);
    } else {
      searchParam.delete("timeRangeStartDate");
    }
    if (timeRangeEndDate) {
      searchParam.set("timeRangeEndDate", timeRangeEndDate);
    } else {
      searchParam.delete("timeRangeEndDate");
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
    getQueryList(debounceValue);
  }

  const closeModel = () => {
    setViewModal(false);
    setEventId("");
  };

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParam.delete("page");
    }
    if (!status) {
      searchParam.delete("status");
    }
    if (!userType) {
      searchParam.delete("userType");
    }
    if (!problemType) {
      searchParam.delete("problemType");
    }
    if (!timeRange) {
      searchParam.delete("timeRange");
    }
    if (!timeRangeStartDate) {
      searchParam.delete("timeRangeStartDate");
    }
    if (!timeRangeEndDate) {
      searchParam.delete("timeRangeEndDate");
    }
    setSearchParam(searchParam);
    getQueryList(debounceValue);
    getSupportInsights();
  }, [searchParam, debounceValue]);

  useEffect(() => {
    if (viewModal) {
      socketConnection();
    }
  }, [viewModal]);

  const endBroadcastHandler = (_id) => {
    setEventId(_id);
    setViewModal(true);
  };

  //*********Handel refresh icon********* */
  const refreshHandler = (event) => {
    setSearch("");
    setDate("");
    setUserType("user");
    setProblemType("");
    setTimeRange("");
    setTimeRangeStartDate("");
    setTimeRangeEndDate("");
    searchParam.delete("page");
    searchParam.delete("limit");
    searchParam.delete("search");
    searchParam.delete("date");
    searchParam.set("userType", "user");
    searchParam.delete("problemType");
    searchParam.delete("timeRange");
    searchParam.delete("timeRangeStartDate");
    searchParam.delete("timeRangeEndDate");
    setSearchParam(searchParam);
    getQueryList();
    getSupportInsights("user");
  };








  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Support Management</h4>
            <div className="block_user_button">
              <span
                className="user_management_excel"
                onClick={handleExcelDownload}
              >
                {loading ? (
                  <Loader />
                ) : (
                  <div className="csv-image-wrapper">
                    <figure>
                      <img src={csv} alt="csv file download" />
                    </figure>
                  </div>
                )}
              </span>
              <Link to="/support-management/add">
                <button>
                  <AddIcon />
                  Add Support Category
                </button>
              </Link>
              <Link to="/support-management/query-masters">
                <button>
                  Query Masters
                </button>
              </Link>
            </div>
          </div>
          <div className="support-tabs" style={{ display: 'flex', gap: '10px', marginBottom: '16px' }}>
            {[
              { label: 'User', value: 'user' },
              { label: 'Consultant', value: 'cons' },
            ].map((tab) => (
              <button
                key={tab.value || 'all'}
                type="button"
                onClick={() => handleUserTypeTab(tab.value)}
                style={{
                  padding: '8px 18px',
                  borderRadius: '8px',
                  border: userType === tab.value ? '1px solid #FF8989' : '1px solid #ddd',
                  backgroundColor: userType === tab.value ? '#FFEBEB' : '#fff',
                  color: userType === tab.value ? '#D32F2F' : '#333',
                  cursor: 'pointer',
                  fontWeight: userType === tab.value ? 600 : 500,
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <div className="FilterBox FilterArea">
            <div className="form-group search_lg_size userSearch">
              <input
                type="search"
                className={`form-control ${search && "active"}`}
                placeholder="Search"
                value={search || ""}
                style={{ "--color": "#FF8989" }}
                onChange={(e) => setSearch(e.target.value)}
              />
              <span className="user_search_icon">
                <IoSearch />
              </span>
            </div>

            {/* Time Range Filter */}
            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel>Time Range</InputLabel>
                <MuiSelect
                  value={timeRange}
                  onChange={(e) => handleTimeRangeChange(e.target.value)}
                  label="Time Range"
                >
                  <MenuItem value="">
                    <em>All Time Ranges</em>
                  </MenuItem>
                  {timeRangeOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </MuiSelect>
              </FormControl>
            </div>
            
            {timeRange === 'custom' && (
              <>
                <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                  <TextField
                    size="small"
                    type="date"
                    variant="outlined"
                    label="Start Date"
                    value={timeRangeStartDate}
                    onChange={(e) => handleTimeRangeDateChange('start', e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                  <TextField
                    size="small"
                    type="date"
                    variant="outlined"
                    label="End Date"
                    value={timeRangeEndDate}
                    onChange={(e) => handleTimeRangeDateChange('end', e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
              </>
            )}

            {/* Problem Type Filter */}
            <div className="form-group select_sm_width">
              <Select
                className={`form-control ${problemType && "active"}`}
                value={problemType || ""}
                onChange={(e) => setProblemType(e.target.value)}
              >
                <option value="">Problem Type</option>
                {PROBLEM_TYPE &&
                  PROBLEM_TYPE.length > 0 &&
                  PROBLEM_TYPE.map((problem) => {
                    return (
                      <option value={problem.value} key={problem.id}>
                        {problem.name}
                      </option>
                    );
                  })}
              </Select>
            </div>

            {/* Reported Date */}
            <div className="form-group date_picker">
              <DatePicker
                className={`form-control ${date && "active"}`}
                name="startDate"
                selected={date}
                placeholder="Reported On"
                onChange={(date) => setDate(date)}
                isClearable
                maxDate={Date.now()}
              />
            </div>

            <div className="form-group refresh_button" style={{ minWidth: '120px', flex: '0 0 auto', display: 'flex', gap: '10px' }}>
              <SecondaryButton onClick={applyFilter}>
                Apply
              </SecondaryButton>
              <SecondaryButton onClick={refreshHandler}>
                Clear
              </SecondaryButton>
            </div>
          </div>
      
          {/* Numerical Analytics */}
          <ResponsiveAnalytics
            title="Support Analytics"
            data={[
              {
                title: "Total Queries",
                value: supportInsights.totalQueries || 0,
                type: "number"
              },
              {
                title: "Total Resolved",
                value: supportInsights.totalQueriesResolved || 0,
                type: "number"
              },
              {
                title: "Total Pending",
                value: supportInsights.totalPending || 0,
                type: "number"
              },
              {
                title: "Last 24h Queries",
                value: supportInsights.last24HoursTotalQueries || 0,
                type: "number"
              },
              {
                title: "Last 24h Resolved",
                value: supportInsights.last24HoursTotalQueriesResolved || 0,
                type: "number"
              },
              {
                title: "Last 24h Pending",
                value: supportInsights.last24HoursTotalPending || 0,
                type: "number"
              }
            ]}
            className="support-analytics"
          />

      
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>Ticket Number</th>
                  <th>User Type</th>
                  <th>User Name</th>
                  <th>User/Consultant Id</th>
                  <th style={{ minWidth: "200px", maxWidth: "250px" }}>Title</th>

                  <th style={{ minWidth: "120px" }}>Problem Type</th>
                  <th>Mobile Number</th>
                  <th>Reported On</th>

                  <th>Status</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {queryList.length > 0 ? (
                  queryList.map((query, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td>{query?.ticketNumber || "---"}</td>
                          <td>
                            {query?.userType === "cons"
                              ?'Consultant'
                              : 'User'}
                          </td>
                          <td className="user_profile_image">
                            {query?.userType === "cons"
                              ? query?.consultantDetails?.name || "---"
                              : query?.userDetails?.name || "---"}
                          </td>
                          <td>{query?.userType === "cons"
                              ? query?.consultantDetails?.userId || "---"
                              : query?.userDetails?.userId || "---"}</td>
                          <td style={{ 
                            maxWidth: "250px", 
                            minWidth: "200px", 
                            wordWrap: "break-word", 
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            paddingRight: "30px", 
                            paddingLeft: "10px",
                            whiteSpace: "normal",
                            lineHeight: "1.4"
                          }}>
                            {query?.title || "---"}
                          </td>
                     
                          <td style={{ paddingLeft: "30px", paddingRight: "10px", minWidth: "120px", whiteSpace: "nowrap" }}>{query?.supportType || "---"}</td>
                         
                          <td>
                            {query?.userType === "cons" 
                              ? (query?.consultantDetails?.details?.phone ? (
                                  <a href={`tel:${query?.consultantDetails?.details?.phone}`} style={{ color: '#FF8989', textDecoration: 'none' }}>
                                    {query?.consultantDetails?.details?.phone}
                                  </a>
                                ) : "---")
                              : (query?.userDetails?.details?.phone ? (
                                  <a href={`tel:${query?.userDetails?.details?.phone}`} style={{ color: '#FF8989', textDecoration: 'none' }}>
                                    {query?.userDetails?.details?.phone}
                                  </a>
                                ) : "---")}
                          </td>
                        
                          <td>{dateFormat(query.createdAt) || "---"}</td>

                          <td>
                            <span
                              style={{
                                padding: "4px 8px",
                                borderRadius: "4px",
                                fontSize: "12px",
                                fontWeight: "500",
                                backgroundColor:
                                  query?.status === "completed"
                                    ? "#d4edda"
                                    : query?.status === "pending"
                                      ? "#fff3cd"
                                      : "#f8d7da",
                                color:
                                  query?.status === "completed"
                                    ? "#155724"
                                    : query?.status === "pending"
                                      ? "#856404"
                                      : "#721c24",
                              }}
                            >
                              {query?.status || "---"}
                            </span>
                          </td>
                          <td>
                            <div className="action_button">
                              <Link
                                to={`/support-management/view/${query?.isResolved}/${query?._id}/${query?.userType === 'cons'
                                  ? 'Consultant'
                                  : query?.userDetails?.name || 'User'
                                  }/${query?.userType === 'cons'
                                    ? query?.consultantDetails?._id
                                    : query?.userDetails?._id
                                  }/${query?.threadId}/${query.isResolved}/${query?.isAdminReply}`}
                              >
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                 
                                >
                                  <VisibilityIcon className="eye_icon" />
                                </IconButton>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <NotFound
                    cols={9}
                    msg="Support request not found!"
                    icon={NOT_FOUND}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-wrapper mt-4 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3">
              <Typography variant="body2" color="textSecondary">
                Show:
              </Typography>
              <select
                value={pageLimit}
                onChange={(e) => handlePageLimitChange(e)}
                style={{ 
                  padding: '8px 12px', 
                  border: '1px solid #ccc', 
                  borderRadius: '4px',
                  fontSize: '14px',
                  minWidth: '80px'
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <Typography variant="body2" color="textSecondary">
                per page
              </Typography>
            </div>
            
            <div className="d-flex align-items-center gap-2">
              <Typography variant="body2" color="textSecondary">
                Showing {((activePage - 1) * pageLimit) + 1} to {Math.min(activePage * pageLimit, total)} of {total} items
              </Typography>
            </div>
            
            {total > pageLimit ? (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={pageLimit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <ModalBox
        status={viewModal}
        onClose={closeModel}
        title="End Live Broadcast"
        description="Are you sure you want to end this live broadcast?"
        // action={endBroadcast}
        ref={buttonRef}
      />

      {DescriptionModel && (
        <DescriptionModel
          show={descriptionModel}
          close={() => {
            setDescriptionModel(false);
          }}
          description={description}
          title={"Description"}
        />
      )}
      <DownloadPasswordModal />
    </>
  );
};

export default SupportManagement;
